import { useEffect } from 'react'

import { EVENT_ACTION_PAGEVIEW, EVENT_CATEGORY_ARTICLE, EVENT_VALUE_ALL, saveUserEvent } from 'components/common/api/UserEvents'
import { ROUTE_TODAY } from 'components/common/helpers/Paths'
import ArticlesList from '../ArticlesList'

/**
 * Simple article page List component. Used to display articles title and preview
 */
export default function ArticlePageList({ setHeaderTitle, setReturnPath, cache }) {

  useEffect(() => {
    setHeaderTitle('Articles')
    setReturnPath(ROUTE_TODAY)

    saveUserEvent(
      EVENT_CATEGORY_ARTICLE,
      EVENT_ACTION_PAGEVIEW,
      EVENT_VALUE_ALL
    )
  }, [setReturnPath, setHeaderTitle])

  return (
    <ArticlesList
      cache={cache}
    />
  )
}